module.exports = __webpack_public_path__ + "img/sun.db60c35a.svg";